// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

const isCustomDomain =
  typeof window !== "undefined" && window.location.hostname === "fieldops.abadata.ca";

const firebaseConfig = {
  apiKey: "AIzaSyA9Ct8HxnsT7VpfN3MllYdb134aplrU79U",
  authDomain: isCustomDomain ? "fieldops.abadata.ca" : "fieldops-9c190.firebaseapp.com",
  projectId: "fieldops-9c190",
  storageBucket: "fieldops-9c190.appspot.com",
  messagingSenderId: "970121130978",
  appId: "1:970121130978:web:5649dcdeeeb9f28a49bfbb",
  measurementId: "G-QM9JVZMZ75"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const auth = getAuth(app);

export { app, auth, db, storage, functions };
